<script>
  // core components
  import TipoView from "../../viewsERP/Tipo.svelte";
</script>

<div class="flex flex-wrap mt-4">
  <div class="w-full mb-12 px-4">
    <TipoView />
  </div>
</div>
